<script setup lang="ts">
import { useScreen } from '@Shared/utils/useScreen';
defineProps<{
  hasNoData?: boolean;
}>();

const screenSize = useScreen();

const maxDrivers = computed<number>(() => {
  let max: number;
  if (screenSize.value.width >= 3840) {
    max = 7;
  } else if (screenSize.value.width >= 1920) {
    max = 5;
  } else {
    max = 5;
  }

  return max;
});

const getLoadingGradientHeight = computed<string>(() => {
  let scale = 1;
  if (screenSize.value.width >= 3840) {
    scale = 2.5;
  } else if (screenSize.value.width >= 1920) {
    scale = 1.5;
  }

  return `${0.8 * scale}rem`;
});
</script>
<template>
  <div class="relative h-full flex flex-col bg-white rounded-[8px]">
    <div
      v-if="hasNoData"
      class="absolute top-45% left-0 text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold z-1000"
    >
      There are no new responses. <br />Please check again later.
    </div>
    <div class="flex flex-col flex-[1_1_auto] mr-10 h-full">
      <div
        class="mt-2 w-full truncate font-bold xl:min-h-4 3xl:min-h-12 xl:text-4 2xl:text-5.5 3xl:text-11 pb-3 flex-[0_1_auto] pl-6"
      >
        <div class="inline-block loading-gradient h-100% w-33% rounded-2"></div>
      </div>
      <!-- Drivers -->
      <div
        class="grid mt-1 mb-2 3xl:mb-4 gap-4 2xl:gap-6 3xl:gap-8 pl-6"
        :style="{
          'grid-template-columns': `40% 1fr 1fr 0.5fr`,
        }"
        v-for="i in maxDrivers"
        :key="i"
      >
        <div
          class="text-[#333333] truncate leading-normal font-semibold xl:text-3.5 2xl:text-5 3xl:text-10 loading-gradient"
        ></div>
        <div class="justify-self-end xl:text-3.5 2xl:text-5 3xl:text-10 font-bold"></div>
        <div class="justify-self-end self-center loading-gradient w-full"></div>
        <div class="justify-self-start xl:text-3.5 2xl:text-5 3xl:text-10 loading-gradient w-full"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
  height: v-bind('getLoadingGradientHeight');
}
</style>
